import { useState, useEffect } from "react";
import { Modal } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Icons from "scripts/icons";

const Component = ({ data = {} }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { visible } = state;
	const { id, slug, title } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();

	const componentDidUpdate = () => {
		if (hash === `#${Modals.MANAGE}`) {
			if (slug) {
				setState((prevState) => ({
					...prevState,
					visible: true,
				}));
			} else {
				window.location = "/panel/jobs";
			}
		} else {
			setState(initialState);
		}
	};

	const handlePublish = (id) => {
		Modal.confirm({
			title: Resources.manageModal.publishTitle,

			okText: Resources.yes,
			okType: "danger",
			cancelText: Resources.no,
			onOk: () => {
				setState((prevState) => ({ ...prevState, loading: true }));

				API.job
					.status(id)
					.then(() => {
						navigate(pathname);
					})
					.catch(() => {});
			},
		});
	};
	// const handleDelete = (id) => {
	// 	Modal.confirm({
	// 		title: Resources.deleteConfirm,
	// 		okText: Resources.yes,
	// 		okType: "danger",
	// 		cancelText: Resources.no,
	// 		onOk: () => {
	// 			setState((prevState) => ({ ...prevState, loading: true }));

	// 			API.job
	// 				.delete(id)
	// 				.then(() => {})
	// 				.catch(() => {});
	// 		},
	// 	});
	// };

	useEffect(componentDidUpdate, [hash]);

	return (
		<Modal
			className="bk-modal-manage"
			footer={false}
			maskClosable={false}
			onCancel={() => navigate(-1)}
			open={visible}
			width={500}
			destroyOnClose
			title={`${Resources.manage} ${Resources.job} ${title}`}
		>
			<ul className="list">
				<li>
					<Link to={`/job/${slug}`}>
						<Icons.Search doutone="true" />
						{Resources.manageModal.seeDetail}
					</Link>
				</li>
				<li>
					<Link onClick={() => handlePublish(slug)}>
						<Icons.Publish doutone="true" />
						{Resources.manageModal.changePublish}
					</Link>
				</li>
				<li>
					<Link to={`${search}#${Modals.SUBSCRIPTION}`}>
						<Icons.ArrowSquareUp doutone="true" />
						{Resources.manageModal.jobSub}
					</Link>
				</li>
				<li>
					<Link to={`${search}#${Modals.LADDER}`}>
						<Icons.Stair doutone="true" />
						{Resources.manageModal.ladderAd}
					</Link>
				</li>
				<li>
					<Link to={`${search}#${Modals.SPECIAL}`}>
						<Icons.Special doutone="true" />
						{Resources.manageModal.specialAd}
					</Link>
				</li>
				<li>
					<Link to={`${search}#${Modals.BANNER}`}>
						<Icons.BannerAd doutone="true" />
						{Resources.manageModal.bannerAd}
					</Link>
				</li>
				<li>
					<Link to={`/panel/edit/${slug}`}>
						<Icons.Edit doutone="true" />
						{Resources.edit}
					</Link>
				</li>
				{/* <li>
					<Link onClick={() => handleDelete(id)}>
						<Icons.Trash doutone="true" />
						{Resources.delete}
					</Link>
				</li> */}
			</ul>
		</Modal>
	);
};

export default Component;
